// extracted by mini-css-extract-plugin
export default {"default":"Image_default__9sDGp","rounded":"Image_rounded__IImOo","disabled":"Image_disabled__b3O25","overlay":"Image_overlay__21bBZ"};